module.exports = function() {
  return new Worker(__webpack_public_path__ + "8322461bbeed57d3ae15.worker.js");
};